/**
 * mockServer.js
 * Create and configure the mock API server - from Mirage.
 * Mirage will intercept any outgoing HTTP requests from the app and and return
 * our mock responses. Any requests not defined in mirage will be allowed to pass through.
 */
import { Server, Model, RestSerializer } from 'miragejs';
import environment from '@/environment';
import { OAUTH2_TOKEN_RESPONSE } from '@/auth/authMockData';
import uuidIdentityManager from './uuidIdentityManager';
import factories from './factories';
import endpoints from './endpoints';

const ApplicationSerializer = RestSerializer.extend({
  root: true,
  embed: true,
});
/**
 *
 * @param {*} - options object.
 *    - The `test` environment turns off Mirage's artificial latency. For development
 *      the environment key must be set to 'development'.
 */
export default (config = { environment: 'test' }) => new Server({
  identityManagers: {
    application: uuidIdentityManager,
  },
  environment: config.environment,
  models: {
    user: Model,
    transaction: Model,
    dispute: Model,
  },
  serializers: {
    application: ApplicationSerializer,
  },
  factories: {
    user: factories.UsersFactory,
    transaction: factories.TransactionsFactory,
    dispute: factories.DisputesFactory,
  },
  seeds(server) {
    server.createList('user', 24);

    // Create 20 captured transactions.
    server.createList('transaction', 20, {
      status: 'captured',
    });

    // Create 20 refunded transactions.
    server.createList('transaction', 20, {
      status: 'refunded',
    });

    // Create 20 capture-failed transactions.
    server.createList('transaction', 20, {
      status: 'capture-failed',
      failureMessage: 'Your card was declined',
      failureCode: 'NO_FUNDS',
    });

    // Create 10 disputes - status needs_response
    server.createList('dispute', 20, {
      status: 'needs_response',
    });

    // Create 10 disputes - status under_review
    server.createList('dispute', 20, {
      status: 'under_review',
    });
  },
  routes() {

    endpoints.mockUsersApi(this);
    endpoints.mockChargeQueryApi(this);

    this.post(`${environment.getAuthServiceUrl()}/oauth2/token`, () => OAUTH2_TOKEN_RESPONSE);

    // Allow unhandled requests on the current domain to pass through.
    this.passthrough();

    this.passthrough('http://com-icabbi.mini.snplow.net/*');
  },
});
